import React from 'react';
import LOGO from '../../images/sooki-logo.png';
import routeAdmin from '../../lib/routeAdmin.json';
import routeSooki from '../../lib/routeSooki.json';
import { Link } from 'react-router-dom';

const loginNavigationBar = () => {
    return (
        <>
            <div style={{ textAlign: "center" }}>
                {/* <p>マスタ権限</p>
                {routeAdmin.map(data => <a href={data.link}> {data.text}</a>)}
                <p>ソーキ管理者権限</p>
                {routeSooki.map(data => <a href={data.link}> {data.text}</a>)} */}
            </div>
            <header className="header" id="header">
                <div className="header-main">
                    <div className="header-logo">
                        <Link to="/" className="header-logo">
                            <img src={LOGO} alt="SOOKI" />
                        </Link>
                    </div>
                    <div className="header-name">ソーキクラウドポータルシステム</div>
                </div>
                <div className="header-sub">
                </div>
            </header>
        </>
    )
};

export default loginNavigationBar;
